module.exports = __webpack_public_path__ + "media/images/favicons_staging/mstile-310x150-728b6065af224bd24e4c05d3b2c9b1fa.png";